import { Notifier } from '@ga/ui-components/notifications'

export default defineNuxtPlugin(() => {
  const notifier = new Notifier()

  return {
    provide: {
      notifier: notifier.notifications,
    },
  }
})
